// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_1-t0D"};